/* eslint-disable no-useless-computed-key */

import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message, Modal, Select} from "antd";
import clientAPI from "../../service/ApiService";
import {API_COUNTRIES, API_HOTELS} from "../../constants";

function HotelModal({open, hotel, doRefresh}){

    const [loading, setLoading] = useState(false);
    const [countriesLoading, setCountriesLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [form] = Form.useForm();

    const { Option } = Select;

    useEffect(() => {
        if(open <= 0)
            return;
        showModal();
    }, [open]);// eslint-disable-line react-hooks/exhaustive-deps

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        form.resetFields();
        getCountries();
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const onFinish = (data) => {

        setLoading(true);
        let request = {};
        if(hotel === null){
            request = clientAPI.post(API_HOTELS, data);
        }else{
            request = clientAPI.put(API_HOTELS + "/" + hotel.id, data);
        }
        request
            .then(response => {
                setLoading(false);
                setIsModalVisible(false);
                doRefresh();
            })
            .catch(error => {
                setLoading(false);
                message.error(error.response?.data?.data?.error?.message ?? "Undefined error")
            })
    };

    const onFinishFailed = () => {};

    const getCountries = (search=null) => {
        setCountriesLoading(true);

        clientAPI.get(API_COUNTRIES)
            .then(response => {

                let countries = response.data?.data;
                if(!countries || countries.length <= 0 ){
                    setCountries([])
                    return false
                }
                setCountries(countries);
                setCountriesLoading(false);
            })
            .catch(error => {
                message.error("Error loading the countries");
                setLoading(false);
            })
    }


    return (
        <Modal
            title="Create hotel"
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button type={"primary"} form="myForm" key="submit" htmlType="submit" loading={loading}>
                    Submit
                </Button>
            ]}
        >
            <Form
                id="myForm"
                name="basic"
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                    ["name"]: hotel?.name,
                    ["countryId"]: hotel?.countryId,
                    ["brand"]: hotel?.brand,
                }}
            >
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true }]}
                >
                    <Input
                        autoFocus={true}
                    />
                </Form.Item>
                <Form.Item
                    label="Brand"
                    name="brand"
                    rules={[{ required: true }]}
                >
                    <Select>
                        <Option value={"banyan-tree"}>Banyan Tree</Option>
                        <Option value={"angsana"}>Angsana</Option>
                        <Option value={"cassia"}>Cassia</Option>
                        <Option value={"dhawa"}>Dhawa</Option>
                        <Option value={"garrya"}>Garrya</Option>
                        <Option value={"veya"}>Veya</Option>
                        <Option value={"homm"}>HOMM</Option>
                        <Option value={"escape"}>Escape</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Countries"
                    name="countryId"
                    rules={[{ required: true }]}
                >
                    <Select
                        showSearch
                        placeholder="Select a country"
                        loading={countriesLoading}
                    >
                        {countries?.map((country, index) =>
                            <Option key={index} value={country.id}>{country.name}</Option>
                        )}
                    </Select>
                </Form.Item>

            </Form>
        </Modal>
    )
};

export default HotelModal;
